import React, { useState, useEffect } from 'react';
import { Skeleton, SkeletonBlock, Toast } from '@one-thd/sui-atomic-components';
import { useReturnStore } from '@src/stores/returnStore';
import { getDisplayedShipmentGroupCount } from '@src/utils/shipmentUtils';
import { Clock } from '@one-thd/sui-icons';
import { APICallState } from '@src/hooks/useMultiCallCreateReturn';
import { scrollToTop } from '@src/utils/general';

interface ReturnsLoadingFlowProps {
  apiCallState: APICallState;
}

const ReturnsLoadingFlow = ({ apiCallState }: ReturnsLoadingFlowProps) => {
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const displayedShipmentsCount =
    getDisplayedShipmentGroupCount(returnShipments);
  const [isToastOpen, setToastOpen] = useState(true);

  // Scroll window to top when component mounts
  useEffect(() => {
    scrollToTop();
  }, []);

  const totalCount = apiCallState.totalSteps;
  const completedCount = apiCallState.completedCalls.length;

  const onClose = () => {
    setToastOpen(false);
  };

  return (
    <>
      <Skeleton grow data-testid="returns-loading-flow">
        {Array.from({ length: displayedShipmentsCount }).map((__, index) => (
          <SkeletonBlock key={index} />
        ))}
      </Skeleton>
      <Toast
        duration={60000} // by passing auto-dismissal duration
        decoration={<Clock />}
        message={`Please wait while your return is being processed. ${completedCount} of ${totalCount} completed...`}
        onClose={onClose}
        open={isToastOpen}
      />
    </>
  );
};

export default ReturnsLoadingFlow;
